import React, { useContext } from "react";
import DisplayChannelStyles from "../../Styles/ChannelViewer/DisplayChannel.module.css";
import Lists from "../../Common/List.component/List";

import { ContextForClient } from "../../Context_file/ClientContext";
import Scrollbar from "react-scrollbars-custom";
import { fetchRequest } from "../../helper/CustomFetch";

const DisplayChannel = () => {
  const [{ channels }, dispatch] = useContext(ContextForClient);
  const { container, wrapper, id, names } = DisplayChannelStyles;

  const fetchOneChannelPost = async ({ name }) => {
    await dispatch({ type: "SHOW_TIMES_ICON", payload: false });
    await dispatch({ type: "FETCH_CHANNEL_NAME", payload: name });
    const url = `getonechanneltext?channel=${name}`,
      storage = "posts";
    await fetchRequest({ storage, url, dispatch });
  };

  const channel =
    channels && channels instanceof Array ? (
      <nav className="list-group">
        {channels.map(({ name }, index) => {
          let twoLetter =
            name && name.split(" ").length > 1
              ? `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`
              : name.split(" ")[0][0];

          return (
            <div key={index} className={`container d-flex ${wrapper}`}>
              <Lists
                text={twoLetter.toUpperCase()}
                listStyle="none"
                className={id}
                color="#aaa"
              />
              <Lists
                text={name}
                key={index}
                listStyle="none"
                className={`text-capitalize  ${names}`}
                color="#aaa"
                click={() => {
                  fetchOneChannelPost({ name });
                }}
              />
            </div>
          );
        })}
      </nav>
    ) : (
      <div>not found</div>
    );
  return (
    <div className={`${container}`}>
      <Scrollbar>{channel}</Scrollbar>;
    </div>
  );
};

export default DisplayChannel;
